export class OpenMenuOptionsSheet {
    constructor(optionalOptions = {}) {
        this._buttons = document.querySelectorAll('.open-menu-option');

        if (!this._buttons) {
            this.destructor();
            return true;
        }

        let buttonTemplateTextTarget
        let buttonTemplateTarget
        let btnPosition
        let target

        this._buttons.forEach((button) => {
            button.addEventListener("click", (e) => {
                e.preventDefault();

                document.querySelector('body').classList.add('no-scroll');

                buttonTemplateTextTarget = button.dataset.textTarget
                buttonTemplateTarget = button.dataset.target

                btnPosition = window.getOffset(
                    button,
                    document.querySelector('.modal-desktop-menu--add-order .modal-content'),
                    document.querySelector('.modal-desktop-menu--add-order .menu-choosing--data')
                );

                target = document.querySelector(buttonTemplateTarget)
                target.style.display = "flex";
                target.style.left = (btnPosition.dataX) + "px"
                target.style.top = (btnPosition.elementY - 9) + "px"
            })
        })
    }

    destructor() {
        this._buttons = null;
    }
}

export default new OpenMenuOptionsSheet();
